import {
    TIMELINE_FETCHING,
    TIMELINE_FAILED,
    TIMELINE_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case TIMELINE_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case TIMELINE_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case TIMELINE_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  